import template from './details-header.html'

export let detailsHeader = {
	bindings: {
		label   : '<',
		details : '<',
		activity: '<',
	},
	template    : template,
	controllerAs: 'vm',
	controller  : [ '$cookies', '$stateParams', 'CssClasses', 'Validations', 'GlobalConfig', 'ReviewSrv', 'Ramda',
		'GlobalSrv', '$rootScope', '$interval', 'ngNotify',
		function detailsHeaderCtrl ($cookies, $stateParams, CssClasses, Validations, GlobalConfig, ReviewSrv,
			Ramda, GlobalSrv, $rootScope, $interval, ngNotify) {
			const curry = Ramda.curry
			const vm = this
			const icons = CssClasses.icons
			const textColor = CssClasses.textColor
			const currentStage = ($stateParams.currentStage) ? $stateParams.currentStage : $stateParams.stage
			const inHistory = $stateParams.inHistory
			const user = JSON.parse($cookies.get('currentUser'))
			const currentRoleId = JSON.parse($cookies.get('hasRoleId'))

			$rootScope.setHandsProgress = false
			const isWorkplanCommittee = Validations.isWorkplanCommittee(currentRoleId)

			const up = 1
			const down = 0

			const namesList = [
				'name',
				'nameSpace',
				'nameResearch',
				'nameProject',
				'asignatureName',
				'itemName',
				'nameCharge',
				'scheduleTypeName',
				'roleName',
				'comiteeName',
				'titleProject',
				'nameVisibility',
				'projectName',
			]

			const activityHeader = curry((names, label, details) => {
				let name = names.filter(name => Reflect.has(details, name)).map(key => details[key])

				return [ label, ...name ].join(' - ')
			})(namesList)

			angular.extend(this, {
				activityHeader   : activityHeader,
				isTeacher        : Validations.isTeacher,
				currentRoleId    : JSON.parse($cookies.get('hasRoleId')),
				inEvaluation     : Validations.inEvaluation(currentStage),
				inReviewExecution: Validations.inReviewExecution(currentStage),
				inReview         : Validations.inReview(currentStage),
				inApproval       : Validations.inApproval(currentStage),
				inExecution      : Validations.inExecution(currentStage),
				evaluationFinish : 1,
				isDisabled       : false,
			})

			angular.extend(this, {
				classEye     : [ icons.eye, textColor.gray ],
				approvedHand : [ icons.thumbsUp, textColor.gray ],
				repprovedHand: [ icons.thumbsDown, textColor.gray ],
				isEditHands  : isEditHands,
			})

			angular.extend(this, {
				showEye         : showEye,
				approve         : approve,
				reprove         : reprove,
				strategicTracing: strategicTracing,
			})

			let teacherId = $stateParams.teacherId

			if (!teacherId) {
				teacherId = JSON.parse($cookies.get('currentUser')).teacherId
			}

			vm.$onInit = () => {
				setMainLabel(this)
				loadColorsIcons(vm.details)
				isEditHands()
			}

			function setMainLabel (vm) {
				if (Validations.isStudentAttentionType(vm.details)) {
					vm.label = 'de atención a estudiantes'
				} else if (Validations.isActivitiesType(vm.details)) {
					vm.label = 'de actividad'
				}
			}

			function approve (activity, approvedHand, repprovedHand) {
				let stage = setStage(currentStage)
				let json = {
					idTeacher  : teacherId,
					idActivity : activity.workplanTeacherActivityId,
					idEvaluator: user.id,
					idRol      : currentRoleId,
					[stage[0]] : up,
				}
				let iconApprovedValue = approvedHand
				let iconRepprovedValue = repprovedHand

				vm.approvedHand = [ icons.thumbsUp, textColor.blue ]
				vm.repprovedHand = [ icons.thumbsDown, textColor.gray ]

				setHands(json, iconApprovedValue, iconRepprovedValue, stage[1], activity, 1)
			}

			function reprove (activity, approvedHand, repprovedHand) {
				let stage = setStage(currentStage)
				let json = {
					idTeacher  : teacherId,
					idActivity : activity.workplanTeacherActivityId,
					idEvaluator: user.id,
					idRol      : currentRoleId,
					[stage[0]] : down,
				}
				let iconApprovedValue = approvedHand
				let iconRepprovedValue = repprovedHand

				vm.approvedHand = [ icons.thumbsUp, textColor.gray ]
				vm.repprovedHand = [ icons.thumbsDown, textColor.red ]
				setHands(json, iconApprovedValue, iconRepprovedValue, stage[1], activity, 0)
			}

			function showUnauthorizedToast () {
				ngNotify.set('No tiene permiso para revisar actividades de este submódulo. Contacte a su administrador si considera que se trata de un error.', 'warn')
			}

			function setHands (json, iconApprovedValue, iconRepprovedValue, action, activity, status) {
				$rootScope.setHandsProgress = true
				vm.isDisabled = true
				ReviewSrv['set' + action].post(json).$promise.then((dataReturn) => {
					let data = { activity: activity, status: status, currentStage: currentStage }

					GlobalSrv.notify($rootScope, 'ApproveRepprove', data)

					if (!dataReturn.status) {
						vm.approvedHand = iconApprovedValue
						vm.repprovedHand = iconRepprovedValue

						if (dataReturn.code === 'UNAUTHORIZED_SUBMODULE') {
							showUnauthorizedToast()
						}
					}

					$rootScope.setHandsProgress = false
					vm.isDisabled = false
				})
			}

			function setStage (stage) {
				switch (stage) {

				case 'review':
					return [ 'isReviewed', 'Review' ]
				case 'approval':
					return [ 'isApproved', 'Approve' ]
				case 'evaluation':
					return [ 'isAccept', 'Accept' ]
				case 'execution':
					return [ 'isApproved', 'Approve' ]
				case 'reviewExecution':
					return [ 'isExecution', 'ReviewedExecution' ]
				
				}
			}

			function setHeader (activity, value) {
				return {
					idTeacher         : teacherId,
					idActivity        : activity.workplanTeacherActivityId,
					idEvaluator       : user.id,
					idRol             : currentRoleId,
					isStrategicTracing: value,
				}
			}

			function setEyeColor (value) {
				if (value === up) {
					vm.classEye = [ icons.eye, textColor.green ]

					return vm.classEye
				} else {
					vm.classEye = [ icons.eye, textColor.gray ]

					return vm.classEye
				}
			}

			function getSendNotify(name, notificationType) {
				let msg = 'Profesor: se ha eliminado la actividad ' + name + ' del módulo de Seguimiento estratégico'

				let data = {
					idUser                      : null,
					idTeacher                   : teacherId,
					dsName                      : 'Notificación, Seguimiento estratégico',
					dsDescription               : msg,
					idNotification_delivery_type: notificationType,
					is_grouped                  : 1,
				}

				GlobalSrv.sendNotification(data)
			}

			function getValueStrategicTracing(value) {
				switch (value) {

				case up:
					return down
				case down:
					return up
				default:
					return up
				
				}
			}

			function strategicTracing (activity) {
				$rootScope.setHandsProgress = true
				vm.isDisabled = true
				let value = getValueStrategicTracing(activity.isStrategicTracing)

				setEyeColor(value)
				let header = setHeader(activity, value)

				ReviewSrv.setStrategicTracing.post(header).$promise.then((dataReturn) => {
					if (dataReturn.status) {
						activity.isStrategicTracing = Number(value)
						GlobalSrv.notify($rootScope, 'isStrategicTracing', activity)
						/*if (value == 0){
            let name = namesList.filter(name => Reflect.has(this.details, name)).map(key => this.details[key])
            getSendNotify(name, GlobalConfig.notificationType.inbox)
            getSendNotify(name, GlobalConfig.notificationType.email)
          }*/
					} else {
						setEyeColor(value)
					}

					$rootScope.setHandsProgress = false
					vm.isDisabled = false
				})
			}

			function loadColorsIcons (activity) {
				let value = activity.isStrategicTracing

				setEyeColor(value)
				let stage = ''

				if (inHistory) {
					stage = handAvatarInHistory(activity)
				} else {
					stage = setStage(currentStage)[0]
				}

				handsColorSetting(activity[stage])
			}

			function handAvatarInHistory (activity) {
				switch (activity.stageId) {

				case GlobalConfig.workplanIdStages.approval:
					return 'isReviewed'
				case GlobalConfig.workplanIdStages.execution:
					return 'isApproved'
				case GlobalConfig.workplanIdStages.reviewExecution:
					return 'isApproved'
				case GlobalConfig.workplanIdStages.evaluation:
					return 'isExecution'
				case 7:
					return 'isAccept'
				default:
					return 'isReviewed'
				
				}
			}

			function handsColorSetting (state) {
				if (state === up) {
					vm.approvedHand = [ icons.thumbsUp, textColor.blue ]
					vm.repprovedHand = [ icons.thumbsDown, textColor.gray ]
				} else if (state === down) {
					vm.approvedHand = [ icons.thumbsUp, textColor.gray ]
					vm.repprovedHand = [ icons.thumbsDown, textColor.red ]
				} else {
					vm.approvedHand = [ icons.thumbsUp, textColor.gray ]
					vm.repprovedHand = [ icons.thumbsDown, textColor.gray ]
				}
			}

			function isStageFinished() {
				if (Validations.isConsultant(currentRoleId))
					return true
				else if (vm.inReview) {
					return vm.details.stageId != GlobalConfig.workplanIdStages.review
				} else if (vm.inApproval) {
					return vm.details.stageId != GlobalConfig.workplanIdStages.approval
				} else if (vm.inReviewExecution) {
					return vm.details.stageId != GlobalConfig.workplanIdStages.reviewExecution
				} else if (vm.evaluationFinish) {
					return vm.details.stageId != GlobalConfig.workplanIdStages.evaluation
				}
			}

			function showEye () {
				if (vm.inReview || vm.inApproval || vm.inExecution) {
					if (vm.currentRoleId == 9 || vm.currentRoleId == 8) {
						return false//isStageFinished() || vm.isDisabled || isWorkplanCommittee
					} else
						return true
				} else {
					return true
				}
			}

			function isEditHands() {
				if (vm.currentRoleId == 9 && (vm.details.stageId == 2 || vm.details.stageId == 5) || vm.currentRoleId == 8 && (vm.details.stageId == 3 || vm.details.stageId == 6)) {
					return false//isStageFinished() || vm.isDisabled || isWorkplanCommittee
				} else
					return true
			}
		},
	] }



// WEBPACK FOOTER //
// ./src/app/u-faculty/components/activities-review/activity-details/details-header.js